import script from "./GamePlayerCreated.vue?vue&type=script&setup=true&lang=ts"
export * from "./GamePlayerCreated.vue?vue&type=script&setup=true&lang=ts"

import "./GamePlayerCreated.vue?vue&type=style&index=0&id=08a9a87e&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a9a87e"]])

export default __exports__